// extracted by css-extract-rspack-plugin
export default {"cls1":"PaywallPage-cls1_-OG","cls2":"PaywallPage-cls2_JNG PaywallPage-cls1_-OG"};